import React from "react";
import { useNavigate } from "react-router-dom";
import JobContent from "./JobContent";
import JobCardButton from "../Common/Buttons/JobCardButton";

const FindJobCard = ({ jobData }) => {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate(`/job-details/${jobData.jobDetailsLink.split("/")[1]}`);
  };

  return (
    <div className="find-jobs-card d-flex align-items-center">
      <JobContent
        jobTypes={jobData.jobTypes}
        jobTitle={jobData.jobTitle}
        jobId={jobData.jobId}
        jobLink={jobData.jobLink}
        skills={jobData.skills}
        postedDate={jobData.postedDate}
        jobCategory={jobData.category}
        jobLocation={jobData.location}
        jobSalary={jobData.salary}
        description={jobData.description}
      />
      <div className="find-jobs-btn">
        <JobCardButton
          text="Apply Now"
          icon="ri-send-plane-2-line"
          onClick={handleApplyNow}
        />
      </div>
    </div>
  );
};

export default FindJobCard;
